// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LEgR","rootNoMargin":"styles_rootNoMargin__2loMi"};